// @ts-nocheck
import React, { useState } from 'react'
import Modal from '../Modal'
import { AutoColumn } from '../Column'
import styled from 'styled-components'
import { getAddress } from 'utils/addressHelpers'
import { RowBetween } from '../Row'
import { TYPE, CloseIcon } from '../../theme'
import { ButtonError } from '../Button'
// import { StakingInfo } from '../../state/stake/hooks'
import { useStakingContract } from '../../hooks/useContract'
import { SubmittedView, LoadingView } from '../ModalViews'
import { TransactionResponse } from '@ethersproject/providers'
import { useTransactionAdder } from '../../state/transactions/hooks'
// import FormattedCurrencyAmount from '../FormattedCurrencyAmount'
import { useActiveWeb3React } from '../../hooks'
import { Pool } from '../../state/types'

const ContentWrapper = styled(AutoColumn)`
  width: 100%;
  padding: 1rem;
`

interface StakingModalProps {
  isOpen: boolean
  onDismiss: () => void
  toggleVestingstate: any
  poolInfo: Pool
}

export default function UnstakingModal({ isOpen, onDismiss, poolInfo, toggleVestingstate }: StakingModalProps) {
  const { account } = useActiveWeb3React()
  // monitor call to help UI loading state
  const addTransaction = useTransactionAdder()
  const [hash, setHash] = useState<string | undefined>()
  const [attempting, setAttempting] = useState(false)
  function wrappedOndismiss() {
    setHash(undefined)
    setAttempting(false)
    onDismiss()
  }

  const stakingContract = useStakingContract(getAddress(poolInfo.contractAddress))
  async function onVesting() {
    if (stakingContract) {
      setAttempting(true)
      await stakingContract
        .setVestingConfig(true, { gasLimit: 300000 })
        .then((response: TransactionResponse) => {
          addTransaction(response, {
            summary: `Vesting disabled`
          })
          toggleVestingstate(true)
          setHash(response.hash)
        })
        .catch((error: any) => {
          setAttempting(false)
          toggleVestingstate(false)
         //console.log(error)
        })
    }
  }

  let error: string | undefined
  if (!account) {
    error = 'Connect Wallet'
  }

  return (
    <Modal isOpen={isOpen} onDismiss={wrappedOndismiss} maxHeight={90}>
      {!attempting && !hash && (
        <ContentWrapper gap="lg">
          <RowBetween>
            <TYPE.mediumHeader>Are you sure ?</TYPE.mediumHeader>
            <CloseIcon onClick={wrappedOndismiss} />
          </RowBetween>
          <AutoColumn justify="center" gap="md">
            <TYPE.body>
              Keep this button on for rewards to be vested in 6 months in 4 tranches. If this button is off you can
              claim 50% of your rewards when the staking period ends and the rest will be burnt immediately
            </TYPE.body>
          </AutoColumn>
          <TYPE.mediumHeader style={{ textAlign: 'center' }}>
            ONLY USE THIS MODE IF YOU KNOW WHAT YOU ARE DOING.
          </TYPE.mediumHeader>
          <ButtonError disabled={!!error} error onClick={onVesting}>
            {error ?? 'Turn off Vesting Mode'}
          </ButtonError>
        </ContentWrapper>
      )}
      {attempting && !hash && (
        <LoadingView onDismiss={wrappedOndismiss}>
          <AutoColumn gap="12px" justify={'center'}>
            <TYPE.body fontSize={20}>Processing Request</TYPE.body>
          </AutoColumn>
        </LoadingView>
      )}
      {hash && (
        <SubmittedView onDismiss={wrappedOndismiss} hash={hash}>
          <AutoColumn gap="12px" justify={'center'}>
            <TYPE.largeHeader>Vesting Turned OFF</TYPE.largeHeader>
          </AutoColumn>
        </SubmittedView>
      )}
    </Modal>
  )
}
